import type { Appointment, AppointmentStatus } from "@myapp/contract";
import {
  buildDeleteDialogOptions,
  type RecordedWork,
} from "../../../shared/lib/deleteDialogOptions";
import type { DeleteDialogOptions } from "../../../shared/hooks/useDeleteDialog";

type AppointmentLike = Pick<Appointment, "status" | "schedule" | "seriesId">;

const COMPLETED_STATUSES: AppointmentStatus[] = ["COMPLETED", "COMPLETED_WITH_FOLLOW_UP"];

/**
 * How far the work on a Termin got — what deleting it would erase.
 *
 * The office may delete a Termin in any state (`DeleteAppointmentUseCase` no longer refuses), so
 * this is not a gate: it only decides how loud the confirm dialog is. "Started" is the presence of
 * `actualWorkStartsAt`, not a status — a PLANNED Termin the technician has begun has Ist-Zeiten
 * too.
 */
export const getAppointmentRecordedWork = (
  appointment: Pick<Appointment, "status" | "schedule">,
): RecordedWork => {
  if (COMPLETED_STATUSES.includes(appointment.status)) return "completed";
  return appointment.schedule.actualWorkStartsAt != null ? "started" : null;
};

/** The options `useDeleteDialog.openDelete` takes for this Termin — one place, every caller. */
export const getAppointmentDeleteDialogOptions = (
  appointment: AppointmentLike,
): DeleteDialogOptions =>
  buildDeleteDialogOptions({
    noun: "Termin",
    recorded: getAppointmentRecordedWork(appointment),
    isSeries: appointment.seriesId != null,
  });
